var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import FolderLockSvg from './folder-lock.icon.svg';
export const FolderLockIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: FolderLockSvg });
};
_react_refresh_temp_1 = FolderLockIcon;
$RefreshReg$(_react_refresh_temp_1, "FolderLockIcon");
